import { Box, SectionHeader, ListItem, AHSeparator } from "arkh";
import { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { useFragment, useMutation } from "react-relay";
import { graphql } from "relay-runtime";
import {
  StorecastScreenAdminModeSelector_StorecastScreen$key,
  StorecastDeviceInputMode,
} from "./__generated__/StorecastScreenAdminModeSelector_StorecastScreen.graphql";

import { StorecastScreenAdminModeSelectorMutation } from "./__generated__/StorecastScreenAdminModeSelectorMutation.graphql";

export function StorecastScreenModeSelector(props: {
  screen: StorecastScreenAdminModeSelector_StorecastScreen$key;
}) {
  const storecastScreen = useFragment(
    graphql`
      fragment StorecastScreenAdminModeSelector_StorecastScreen on StorecastScreen {
        id
        inputMode
        recommendedInputMode
      }
    `,
    props.screen
  );
  const [setMode] = useMutation<StorecastScreenAdminModeSelectorMutation>(
    graphql`
      mutation StorecastScreenAdminModeSelectorMutation(
        $screenId: ID!
        $mode: StorecastDeviceInputMode!
      ) @raw_response_type {
        storecast {
          setScreenInputMode(screenId: $screenId, inputMode: $mode) {
            id
            inputMode
          }
        }
      }
    `
  );
  const onSelect = useCallback(
    (mode: StorecastDeviceInputMode) => {
      setMode({
        variables: { screenId: storecastScreen.id, mode },
        optimisticResponse: {
          storecast: {
            setScreenInputMode: {
              id: storecastScreen.id,
              inputMode: mode,
            },
          },
        },
      });
    },
    [storecastScreen.id, setMode]
  );
  return (
    <Box spaceTop="large">
      <SectionHeader>
        <SectionHeader.Title>
          <FormattedMessage
            description="StorecastScreenAdmin mode selector section title"
            defaultMessage="Signage input mode"
          />
        </SectionHeader.Title>
      </SectionHeader>
      <ListItem
        right={
          <>
            {storecastScreen.recommendedInputMode === "SIGNAGE" ? (
              <RecomendedText />
            ) : null}
            <ListItem.SingleSelectIndicator
              selected={storecastScreen.inputMode === "SIGNAGE"}
            />
          </>
        }
        isFirst
        border="border-primary"
        onPress={() => onSelect("SIGNAGE")}
      >
        <ListItem.Title>
          <FormattedMessage
            description="StorecastScreenAdmin mode selector item title"
            defaultMessage="Signage"
          />
        </ListItem.Title>
      </ListItem>
      <AHSeparator />
      <ListItem
        right={
          <>
            {storecastScreen.recommendedInputMode === "TOUCH" ? (
              <RecomendedText />
            ) : null}
            <ListItem.SingleSelectIndicator
              selected={storecastScreen.inputMode === "TOUCH"}
            />
          </>
        }
        isLast
        border="border-primary"
        onPress={() => onSelect("TOUCH")}
      >
        <ListItem.Title>
          <FormattedMessage
            description="StorecastScreenAdmin mode selector item title"
            defaultMessage="Touch"
          />
        </ListItem.Title>
      </ListItem>
    </Box>
  );
}
function RecomendedText() {
  return (
    <Box spaceRight="xsmall">
      <ListItem.DetailActionText>
        <FormattedMessage
          description="StorecastScreenAdmin mode selector item recommended title"
          defaultMessage="Recommended"
        />
      </ListItem.DetailActionText>
    </Box>
  );
}
